"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _fileInputModule = _interopRequireDefault(require("./fileInput.module.css"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactDropzone = _interopRequireDefault(require("react-dropzone"));

var _button = _interopRequireDefault(require("../button/button"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FileInput = function FileInput(props) {
  var id = props.id,
      label = props.label,
      onDrop = props.onDrop,
      accepts = props.accepts,
      allowMultiple = props.allowMultiple,
      disabled = props.disabled,
      buttonLabel = props.buttonLabel,
      buttonVariant = props.buttonVariant,
      name = props.name,
      buttonOnly = props.buttonOnly;
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_reactDropzone.default, {
    onDrop: onDrop,
    accept: accepts,
    multiple: allowMultiple,
    disabled: disabled
  }, function (_ref) {
    var getRootProps = _ref.getRootProps,
        getInputProps = _ref.getInputProps;
    return _react.default.createElement("div", {
      id: id ? id : null,
      style: {
        display: 'flex'
      }
    }, _react.default.createElement("div", _extends({
      id: id ? "".concat(id, "_file_input") : null
    }, getRootProps(), {
      style: buttonOnly ? {
        display: 'none'
      } : {},
      className: (0, _classnames.default)(_fileInputModule.default["file-input"], _fileInputModule.default['form-control'], disabled ? _fileInputModule.default['disabled'] : '')
    }), _react.default.createElement("input", _extends({
      id: id ? "".concat(id, "_input") : null
    }, getInputProps(), {
      name: name
    })), _react.default.createElement("span", {
      id: id ? "".concat(id, "_label") : null
    }, label)), _react.default.createElement("div", _extends({
      id: id ? "".concat(id, "_button_wrapper") : null
    }, getRootProps()), _react.default.createElement(_button.default, {
      id: id ? "".concat(id, "_button") : null,
      variant: buttonVariant ? buttonVariant : "tertiary",
      label: buttonLabel ? buttonLabel : "Choose file",
      arrowDirection: "right",
      disabled: disabled
    })));
  }));
};

FileInput.propTypes = {
  /** String text that specifies a unique id for an HTML element. Consistent Id type: snake_case*/
  id: _propTypes.default.string,

  /** String text displayed in the drag and drop zone */
  label: _propTypes.default.string,

  /** Callback called when files are selected - dropped. Will be invoked with the first argument the selected -
   * dropped files eg: (files) => {}*/
  onDrop: _propTypes.default.func,

  /** Array of strings. The string must match a  MIME type. Only the selected MIME types will be accepted by the
   * component */
  accepts: _propTypes.default.arrayOf(_propTypes.default.string),

  /** Boolean indicating if the component should accept multiple files at once. Defaults to false */
  allowMultiple: _propTypes.default.bool,

  /** Boolean indicating if the component is disabled. Defaults to false */
  disabled: _propTypes.default.bool
};
var _default = FileInput;
exports.default = _default;